import React, { useState, useEffect } from "react";
import {
  Accordions,
  Avatar,
  Box,
  Button,
  Checkbox,
  getColor,
  Modal,
  Tooltip,
  Typography,
} from "fds";
import "./index.scss";
import utilsCommon from "../../../shared/utils/common";
import { Member } from "../../../types/workgroup";
import useWorkgroupStore from "../../../redux/dispatcher/useWorkgroupStore";
import { getUserInfoFromLocalStorage } from "../../../shared/utils/auth";
import { LoginDto } from "../../../types/auth";
import WorkgroupManagerIcon from "../../../components/WorkgroupManagerIcon";
import useCheckboxGroup from "fds/src/hooks/useCheckboxGroup";
import { t } from "i18next";
import NameTag from "../../../components/NameTag";

const SelectParticipantModal = ({
  open,
  userList,
  participantList,
  manager,
  onClose,
  onSubmit,
}: {
  open: boolean;
  userList: Member[];
  participantList?: Member[];
  manager: string;
  onClose: () => void;
  onSubmit: (userIds: string[]) => void;
}) => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const checkboxgroup = useCheckboxGroup<string>();
  const { workgroupState } = useWorkgroupStore();
  useEffect(() => {
    if (open) {
      checkboxgroup.handleAllClick(
        participantList?.map((item) => item.userId) ?? []
      );
    }
  }, [open]);
  /** 사용자 리스트 표시 */
  const renderMemberInfo = (member: Member) => {
    const userList = workgroupState.workgroupDetail.workgroup.members;
    const manager = userList?.filter(
      (item: Member) =>
        item?.userId === workgroupState.workgroupDetail.workgroup?.managerId
    )[0];
    const isWorkgroupManager = manager.userId === member.userId;
    return (
      <Box alignItems="center" height={52} classes="memberTag">
        <NameTag
          user={member}
          height={52}
          subLeftIcon={
            isWorkgroupManager ? (
              <WorkgroupManagerIcon
                style={{
                  position: "absolute",
                  bottom: "-5px",
                  insetInlineEnd: "-12px",
                }}
              />
            ) : undefined
          }
          withoutUserId={false}
          avatarSize={"32"}
          width={"calc(100% - 20px)"}
        />
        <Checkbox
          roundshape
          check={
            member?.userId === loginDto.userInfo.userId ||
            checkboxgroup.isSelected(member.userId)
          }
          disable={member?.userId === loginDto.userInfo.userId}
          onClick={() => checkboxgroup.handleClick(member.userId)}
        />
      </Box>
    );
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t("workgroup.selectUser")}
      isFooterDivider
      bodyPadding={"0 28px 0 20px"}
      footer={
        <Box justifyContent="space-between" width={"100%"} alignItems="center">
          <Button
            btnStyle="link"
            label={
              checkboxgroup.selected.length ===
              workgroupState.workgroupDetail.workgroup.members.length
                ? t("common.unselectAll")
                : t("common.selectAll")
            }
            textColor={getColor("COLOR_TEXT_BRAND")}
            onClick={() =>
              checkboxgroup.handleAllClick(
                checkboxgroup.selected.length ===
                  workgroupState.workgroupDetail.workgroup.members.length
                  ? []
                  : workgroupState.workgroupDetail.workgroup.members.map(
                      (item: Member) => item.userId
                    )
              )
            }
          />
          <Box classes="mg ml-auto">
            <Button
              btnStyle="fill"
              label={t("common.cancel")}
              type="secondary"
              onClick={onClose}
            />
            <Button
              btnStyle="fill"
              label={t("common.apply")}
              classes="mg ml-8"
              onClick={() => {
                onSubmit(checkboxgroup.selected);
                onClose();
              }}
            />
          </Box>
        </Box>
      }
      bodyHeight={564}
      body={
        <Box direction="column" classes="overflow-scroll">
          <Accordions
            hasBorder={false}
            label={t("workgroup.manager")}
            initialOpenStatus
          >
            {userList.filter((item1: Member) => item1.userId === manager)[0] &&
              renderMemberInfo(
                userList.filter((item1: Member) => item1.userId === manager)[0]
              )}
          </Accordions>
          <Accordions
            hasBorder={false}
            label={t("common.internalUser")}
            initialOpenStatus
            labelLeftComponent={
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_INFO")}
              >
                {
                  userList.filter(
                    (item1: Member) =>
                      item1.userType === 1 && item1.userId !== manager
                  )?.length
                }
              </Typography>
            }
          >
            {userList
              ?.filter(
                (item1: Member) =>
                  item1.userType === 1 && item1.userId !== manager
              )
              ?.map((item: Member) => renderMemberInfo(item))}
          </Accordions>
          <Accordions
            hasBorder={false}
            initialOpenStatus
            label={t("common.externalUser")}
            labelLeftComponent={
              <Typography
                type="subtitle2"
                exactColor={getColor("COLOR_TEXT_INFO")}
              >
                {
                  userList.filter((item1: Member) => item1.userType === 2)
                    .length
                }
              </Typography>
            }
          >
            {userList
              ?.filter((item1: Member) => item1.userType === 2)
              ?.map((item: Member) => renderMemberInfo(item))}
          </Accordions>
        </Box>
      }
      width={600}
    />
  );
};

export default SelectParticipantModal;
